import Icon from "components/atoms/Icon/Icon";
import { usePagination } from "utils/hooks/usePagination";

interface FooterProps {
  totalItems: number;
  pageSize?: number;
  className?: string;
}
export const Footer = (props: FooterProps) => {
  const { totalItems, pageSize, className } = props;
  const {
    isFirstPage,
    isLastPage,
    showing: actualShowingPage,
    handleGoPreviousPage,
    handleGoFirstPage,
    handleGoLastPage,
    handleGoNextPage,
  } = usePagination({ totalItems, pageSize });

  const formatCompactNumber = (value: number) => {
    return new Intl.NumberFormat("en-US", {
      notation: "compact",
      maximumFractionDigits: 1,
    }).format(value);
  };
  return (
    <footer
      className={`flex items-center h-fit p-4 justify-between w-full border-t border-gray-700 bg-gray-800 ${className}`}
    >
      <div
        className="flex items-center text-gray-400 gap-1"
        style={{
          fontFamily: "Inter",
          fontWeight: "200",
          fontSize: 13,
        }}
      >
        Showing
        <div>
          {" "}
          <strong className="font-bold text-white-500">
            {formatCompactNumber(
              actualShowingPage > totalItems ? totalItems : actualShowingPage
            )}
          </strong>{" "}
        </div>
        of
        <strong className="font-bold text-white-500">
          {" "}
          {formatCompactNumber(totalItems)}
        </strong>
      </div>
      <div className="flex sm:flex-row gap-4 sm:gap-6 justify-end">
        <div className="pagination">
          <button
            className={
              isFirstPage || totalItems === 0
                ? "disabled"
                : "hover:bg-gray-700 text-white-500"
            }
            onClick={() => handleGoFirstPage()}
          >
            <Icon name="angle-left-double" size={16} />
          </button>
          <button
            className={
              isFirstPage || totalItems === 0
                ? "disabled"
                : "hover:bg-gray-700 text-white-500"
            }
            onClick={() => handleGoPreviousPage()}
          >
            <Icon name="angle-left" size={16} />
          </button>
          <button
            className={
              isLastPage || totalItems === 0
                ? "disabled"
                : "hover:bg-gray-700 text-white-500"
            }
            onClick={() => handleGoNextPage()}
          >
            <Icon name="angle-right" size={16} />
          </button>
          <button
            className={
              isLastPage || totalItems === 0
                ? "disabled"
                : "hover:bg-gray-700 text-white-500"
            }
            onClick={() => handleGoLastPage()}
          >
            <Icon name="angle-right-double" size={16} />
          </button>
        </div>
      </div>
    </footer>
  );
};
